<template>
    <at-ta :members="globalAttributes" :allow-spaces="false" :ats="['$(']" @insert="handleAt">
        <!--        <div class="your-editor" contenteditable></div>-->
        <v-textarea v-model="content"
                    :error="!content"
                    :rules="validationRules"
                    outline
                    :no-resize="type==='textfield'"
                    :class="type==='textfield'?'textfieldClone': ''" @input="updateValue()">
        </v-textarea>
        <!--
         :error="!content"
                     :error-messages="!content? validationMsg:''"
         -->

    </at-ta>
</template>


<script>
    import AtTa from 'vue-at/dist/vue-at-textarea'
    import {mapGetters} from "vuex";
    import VueTribute from 'vue-tribute'

    export default {
        components: {AtTa, VueTribute},
        // props: {
        //     data: {
        //         type: Object,
        //         default: () => {
        //             return {}
        //         }
        //     },
        //     type: {
        //         type: String,
        //         default: () => {
        //             return 'textarea'
        //         }
        //     },
        //     validation: {
        //         type: Object,
        //         default: () => {
        //             return {}
        //         }
        //     }
        // },

        props: ['value', 'type', 'validationRules'],
        data() {
            return {
                content: this.value
            }
        },
        computed: {
            globalAttributes() {
                let variables = this.$store.state.blocksBuild.variables;
                return [...new Set(variables.map(a => a.variable))];
            }
        },
        created() {
            // console.log(this.value, ' autocom vmodel')
        },
        methods: {
            updateValue() {
                this.$emit('input', this.content);
            },
            handleAt(name) {
                this.content = this.content.replace(/\s?$/, '') + ')';
                this.$emit('input', this.content);

            }
        },
        watch: {
            value(val) {
                console.log(val, ' this.value')
                this.content = val
            },

        }
    }
</script>
